const isTestMode = false;
export const API_URL = isTestMode
  ? "http://localhost:5001"
  : "https://y7hgkmjji8.execute-api.us-west-2.amazonaws.com";
export const LOCAL_STORAGE_KEY = "meta_market_logged";
